<div class="sw-wrap"
     [class.sw-wrap--active]="state === 'RUNNING'"
     [class.sw-wrap--paused]="state === 'CHECKED_OUT'"
     [class.sw-wrap--syncing]="state === 'SYNCING'">

  <span class="sw-dot"
    [class.sw-dot--active]="state === 'RUNNING'"
    [class.sw-dot--paused]="state === 'CHECKED_OUT'">
  </span>

  <div class="sw-timer">
    <span class="sw-time" style="font-variant-numeric:tabular-nums">{{ timerDisplay }}</span>
    <span class="sw-label">
      @switch (state) {
        @case ('RUNNING')     { Checked in }
        @case ('CHECKED_OUT') { Today }
        @case ('SYNCING')     {
          <mat-spinner diameter="10" style="display:inline-block;vertical-align:middle;margin-right:4px"></mat-spinner>
          Syncing…
        }
        @default              { Not checked in }
      }
    </span>

    @if (locationWarning && state === 'RUNNING') {
      <span class="sw-loc-warn">
        <mat-icon style="font-size:12px;width:12px;height:12px;vertical-align:middle">location_off</mat-icon>
        Location unavailable
      </span>
    }
  </div>

  <span class="sw-divider"></span>

  <div class="sw-action">
    @if (loading) {
      <mat-spinner diameter="16" class="sw-spinner"></mat-spinner>
    }

    @if (!loading && state !== 'RUNNING') {
      <button class="sw-btn sw-btn--in" (click)="checkIn()" [disabled]="!canCheckIn"
              [title]="state === 'CHECKED_OUT' ? 'Resume' : 'Check In'">
        <mat-icon>login</mat-icon>
        <span>{{ state === 'CHECKED_OUT' ? 'Resume' : 'Check In' }}</span>
      </button>
    }

    @if (!loading && state === 'RUNNING') {
      <button class="sw-btn sw-btn--out" (click)="checkOut()" [disabled]="!canCheckOut" title="Check Out">
        <mat-icon>pause</mat-icon>
        <span>Check Out</span>
      </button>
    }
  </div>

</div>

<div class="loc-help-backdrop" *ngIf="showLocationHelp" (click)="closeLocationHelp()"></div>
<div class="loc-help" *ngIf="showLocationHelp" role="dialog" aria-label="Allow location access">
  <div class="loc-help-head">
    <span class="material-icons">location_off</span>
    <h3>Location is blocked</h3>
    <button class="loc-help-x" (click)="closeLocationHelp()" aria-label="Close">
      <span class="material-icons">close</span>
    </button>
  </div>

  <p class="loc-help-lead">
    Check-in needs your location, but it’s currently blocked for this site. Your browser won’t ask
    again automatically — please turn it back on:
  </p>

  <ol class="loc-help-steps">
    <li *ngFor="let step of locationHelpSteps">{{ step }}</li>
  </ol>

  <div class="loc-help-actions">
    <button class="loc-help-secondary" (click)="closeLocationHelp()">Close</button>
    <button class="loc-help-primary" (click)="retryFromHelp()">
      <span class="material-icons">my_location</span> I’ve allowed it — Retry
    </button>
  </div>
</div>
